import React from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import Layout from "../pages/Layout/Layout";
import ToastNotification from "../pages/component/common/toastNotification";
import LoginForm from "../pages/Login/Index";
import Dashboard from "../pages/dashboard";
import { RootState } from "../globalState/allReducers";
import { useSelector } from "react-redux";
import SaleOrder from "../pages/dashboard/saleOrder/NewOrders";
import InvoicesPayments from "../pages/dashboard/invoice&payment/Invoices&Payments";
import OrderHistoryComponent from "../pages/dashboard/saleOrder/OrderHistory";
import ReturnsManagement from "../pages/dashboard/returnManagement/ReturnsManagement";
import CustomerEnrolment from "../pages/dashboard/customerEnrolment/CustomerEnrolment";
import DeliveryManagement from "../pages/dashboard/deliveryManagement/DeliveryManagement";
import PaymentCallbackPage from "../pages/dashboard/invoice&payment/PaymentCallbackPage";
import QiCardReturnPage from "../pages/dashboard/invoice&payment/QiCardReturnPage";
import MobilePaymentStatus from "../pages/mobile/MobilePaymentStatus";
import WorkflowPortal from "../pages/dashboard/workflowPortal/WorkflowPortal";
import ItemControlRelease from "../pages/dashboard/itemControlRelease/ItemControlRelease";
import InventoryReconciliation from "../pages/dashboard/inventoryReconciliation/InventoryReconciliation";
import ForceChangePassword from "../pages/ForceChangePassword/Index";
import CodSalesRep from "../pages/dashboard/codSalesRep/CodSalesRep";
import CodSalesManager from "../pages/dashboard/codSalesManager/CodSalesManager";
import CodSalesRepReportsPage from "../pages/dashboard/codReports/CodSalesRepReportsPage";
import CodSalesManagerReportsPage from "../pages/dashboard/codReports/CodSalesManagerReportsPage";
import SalesRepEnrolment from "../pages/dashboard/salesRepEnrolment/SalesRepEnrolment";
import SalesManagerEnrolment from "../pages/dashboard/salesManagerEnrolment/SalesManagerEnrolment";
import WalletBalance from "../pages/dashboard/wallet/WalletBalance";
import CheckoutResume from "../utils/CheckoutResume";
import SupervisorReportsPage from "../pages/dashboard/opsReports/SupervisorReportsPage";
import WhmReportsPage from "../pages/dashboard/opsReports/WhmReportsPage";

const OrderHistory = () => <OrderHistoryComponent refreshKey={0} />;

const PrivateRoute: React.FC = () => {
  const loginDetails = useSelector((state: RootState) => state.authReducer);
  const token = localStorage.getItem("token");
  const isLoginSucceeded = loginDetails?.loginDetials?.token || token;

  if (sessionStorage.getItem("tempPassword")) {
    return <Navigate replace to="/change-password" />;
  }

  return isLoginSucceeded ? <Outlet /> : <Navigate replace to="/" />;
};

const AdminRoute: React.FC = () => {
  const loginDetails = useSelector((state: RootState) => state.authReducer);
  const token = localStorage.getItem("token");
  const isLoginSucceeded = loginDetails?.loginDetials?.token || token;

  if (!isLoginSucceeded) {
    return <Navigate replace to="/" />;
  }

  const userRole = loginDetails?.loginDetials?.role?.toLowerCase();
  if (userRole === "admin") {
    return <Outlet />;
  }

  return <Navigate replace to="/dashboard" />;
};

const SupervisorRoute: React.FC = () => {
  const loginDetails = useSelector((state: RootState) => state.authReducer);
  const token = localStorage.getItem("token");
  const isLoginSucceeded = loginDetails?.loginDetials?.token || token;

  if (!isLoginSucceeded) {
    return <Navigate replace to="/" />;
  }

  const userRole = loginDetails?.loginDetials?.role?.toLowerCase();
  if (userRole === "supervisor") {
    return <Outlet />;
  }

  return <Navigate replace to="/dashboard" />;
};

const WHMRoute: React.FC = () => {
  const loginDetails = useSelector((state: RootState) => state.authReducer);
  const token = localStorage.getItem("token");
  const isLoginSucceeded = loginDetails?.loginDetials?.token || token;

  if (!isLoginSucceeded) {
    return <Navigate replace to="/" />;
  }

  const userRole = loginDetails?.loginDetials?.role?.toLowerCase();
  if (userRole === "whm") {
    return <Outlet />;
  }

  return <Navigate replace to="/dashboard" />;
};

const SalesRepRoute: React.FC = () => {
  const loginDetails = useSelector((state: RootState) => state.authReducer);
  const token = localStorage.getItem("token");
  const isLoginSucceeded = loginDetails?.loginDetials?.token || token;

  if (!isLoginSucceeded) {
    return <Navigate replace to="/" />;
  }

  const userRole = loginDetails?.loginDetials?.role?.toLowerCase();
  if (userRole === "salesrep") {
    return <Outlet />;
  }

  return <Navigate replace to="/dashboard" />;
};

const SalesManagerRoute: React.FC = () => {
  const loginDetails = useSelector((state: RootState) => state.authReducer);
  const token = localStorage.getItem("token");
  const isLoginSucceeded = loginDetails?.loginDetials?.token || token;

  if (!isLoginSucceeded) {
    return <Navigate replace to="/" />;
  }

  const userRole = loginDetails?.loginDetials?.role?.toLowerCase();
  if (userRole === "salesmanager") {
    return <Outlet />;
  }

  return <Navigate replace to="/dashboard" />;
};

const UserOnlyRoute: React.FC = () => {
  const loginDetails = useSelector((state: RootState) => state.authReducer);
  const token = localStorage.getItem("token");
  const isLoginSucceeded = loginDetails?.loginDetials?.token || token;

  if (!isLoginSucceeded) {
    return <Navigate replace to="/" />;
  }

  const userRole = loginDetails?.loginDetials?.role?.toLowerCase();
  if (userRole === "admin") {
    return <Navigate replace to="/CustomerEnrolment" />;
  }
  if (userRole === "supervisor") {
    return <Navigate replace to="/workflowPortal" />;
  }
  if (userRole === "whm") {
    return <Navigate replace to="/itemControlRelease" />;
  }
  if (userRole === "salesrep") {
    return <Navigate replace to="/codSalesRep" />;
  }
  if (userRole === "salesmanager") {
    return <Navigate replace to="/codSalesManager" />;
  }

  return <Outlet />;
};

const PublicRoute: React.FC = () => {
  const loginDetails = useSelector((state: RootState) => state.authReducer);
  const token = localStorage.getItem("token");
  const isLoginSucceeded = loginDetails?.loginDetials?.token || token;

  if (isLoginSucceeded) {
    if (sessionStorage.getItem("tempPassword")) {
      return <Navigate replace to="/change-password" />;
    }
    const userRole = loginDetails?.loginDetials?.role?.toLowerCase();
    if (userRole === "admin") {
      return <Navigate replace to="/CustomerEnrolment" />;
    }
    if (userRole === "supervisor") {
      return <Navigate replace to="/workflowPortal" />;
    }
    if (userRole === "whm") {
      return <Navigate replace to="/itemControlRelease" />;
    }
    if (userRole === "salesrep") {
      return <Navigate replace to="/codSalesRep" />;
    }
    if (userRole === "salesmanager") {
      return <Navigate replace to="/codSalesManager" />;
    }
    return <Navigate replace to="/dashboard" />;
  }

  return <Outlet />;
};

function DefaultRedirect() {
  const loginDetails = useSelector((state: RootState) => state.authReducer);
  const token = localStorage.getItem("token");
  const isLoginSucceeded = loginDetails?.loginDetials?.token || token;

  if (isLoginSucceeded) {
    if (sessionStorage.getItem("tempPassword")) {
      return <Navigate replace to="/change-password" />;
    }
    const userRole = loginDetails?.loginDetials?.role?.toLowerCase();
    if (userRole === "admin") {
      return <Navigate replace to="/CustomerEnrolment" />;
    }
    if (userRole === "supervisor") {
      return <Navigate replace to="/workflowPortal" />;
    }
    if (userRole === "whm") {
      return <Navigate replace to="/itemControlRelease" />;
    }
    if (userRole === "salesrep") {
      return <Navigate replace to="/codSalesRep" />;
    }
    if (userRole === "salesmanager") {
      return <Navigate replace to="/codSalesManager" />;
    }
    return <Navigate replace to="/dashboard" />;
  }

  return <Navigate replace to="/" />;
}

const RouteStart: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/mobile-payment-status" element={<MobilePaymentStatus />} />
          <Route path="/" element={<LoginForm />} />
        </Route>

        {/* Force-change-password: accessible once logged in, outside the app layout */}
        <Route path="/change-password" element={<ForceChangePassword />} />

        <Route element={<PrivateRoute />}>
          <Route path="/payment-callback" element={<PaymentCallbackPage />} />
          <Route path="/payment/return" element={<QiCardReturnPage />} />
          <Route element={<Layout />}>
            <Route element={<UserOnlyRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/saleOrder" element={<SaleOrder />} />
              <Route path="/orderHistory" element={<OrderHistory />} />
              <Route path="/invoicesPayments" element={<InvoicesPayments />} />
              <Route path="/walletBalance" element={<WalletBalance />} />
              <Route
                path="/returnsManagement"
                element={<ReturnsManagement />}
              />
              <Route
                path="/deliveryManagement"
                element={<DeliveryManagement />}
              />
            </Route>
            <Route element={<AdminRoute />}>
              <Route
                path="/CustomerEnrolment"
                element={<CustomerEnrolment />}
              />
              <Route
                path="/SalesRepEnrolment"
                element={<SalesRepEnrolment />}
              />
              <Route
                path="/SalesManagerEnrolment"
                element={<SalesManagerEnrolment />}
              />
            </Route>
            <Route element={<SupervisorRoute />}>
              <Route path="/workflowPortal" element={<WorkflowPortal />} />
              <Route path="/supervisorReports" element={<SupervisorReportsPage />} />
            </Route>
            <Route element={<WHMRoute />}>
              <Route path="/itemControlRelease" element={<ItemControlRelease />} />
              <Route path="/inventoryReconciliation" element={<InventoryReconciliation />} />
              <Route path="/whmReports" element={<WhmReportsPage />} />
            </Route>
            <Route element={<SalesRepRoute />}>
              <Route path="/codSalesRep" element={<CodSalesRep />} />
              <Route path="/codSalesRepReports" element={<CodSalesRepReportsPage />} />
            </Route>
            <Route element={<SalesManagerRoute />}>
              <Route path="/codSalesManager" element={<CodSalesManager />} />
              <Route path="/codSalesManagerReports" element={<CodSalesManagerReportsPage />} />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<DefaultRedirect />} />
      </Routes>

      <ToastNotification />
      <CheckoutResume />
    </Router>
  );
};

export default RouteStart;
